/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_App_Anna_NameInputs */

const en_marketing_app_anna_name = /** @type {(inputs: Marketing_App_Anna_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anna V.`)
};

const es_marketing_app_anna_name = /** @type {(inputs: Marketing_App_Anna_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anna V.`)
};

/**
* | output |
* | --- |
* | "Anna V." |
*
* @param {Marketing_App_Anna_NameInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const marketing_app_anna_name = /** @type {((inputs?: Marketing_App_Anna_NameInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_App_Anna_NameInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_marketing_app_anna_name(inputs)
	return en_marketing_app_anna_name(inputs)
});